import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../components/CSSCustom/toaster.css"; // Import CSS

const toastOptions = {
  position: "top-right", // Position of the toast
  autoClose: 3000, // Closes automatically after 3 seconds
  hideProgressBar: false, // Show progress bar
  closeOnClick: true, // Close on click
  pauseOnHover: true, // Pause when hovered
  draggable: true, // Allow dragging
  theme: "light", // Theme: light or dark
};
const errortoastOptions = {
  position: "top-right", // Position of the toast
  autoClose: 3000, // Closes automatically after 3 seconds
  hideProgressBar: false, // Show progress bar
  closeOnClick: true, // Close on click
  pauseOnHover: true, // Pause when hovered
  draggable: true, // Allow dragging
  theme: "light", // Theme: light or dark
  marginTop:"-32px"
};

// Show toast function
export const showToast = (message, type = "success") => {
  if (type === "success") {
    toast.success(message, {
      ...toastOptions,
      className: "custom-toast custom-toast-success",
    });
  } 
  else if (type === "error") {
    toast.error(message, {
      ...toastOptions,
      className: "custom-toast custom-toast-error",
    });
    
  } 
  else if (type === "info") {
    toast.info(message, {
      ...toastOptions,
      className: "custom-toast custom-toast-info",
    })
  }
  else if (type === "warning") {
    toast.warning(message, {
      ...toastOptions,
      className: "custom-toast custom-toast-warning",
    });
  }
  
};
